import { ChevronLeftOutlineIcon } from '@ikyucom/design-system-icons-react'
// navigation Link だと onClick で追加処理をしているため Remix の Link を利用する
// eslint-disable-next-line no-restricted-imports
import { Link } from '@remix-run/react'
import { RestaurantArea } from '~/components/area/restaurantArea.frag'
import { HeaderLogo } from '~/components/header/HeaderLogo'
import { SideMenuContainer } from '~/components/header/sd/SideMenuContainer'
import type { FragmentType } from '~/lib/graphql'
import { getFragmentData } from '~/lib/graphql'
import { useRes2QueryString } from '~/lib/location/query'
import { useIsFromList, useSmartBack } from '~/navigation'
import { css } from '~/styled-system/css'
import { center } from '~/styled-system/patterns'
import { HeaderWrapper } from '../HeaderWrapper'

type Props = {
  restaurant: FragmentType<typeof RestaurantArea>
}

export function SdGuideHeader(props: Props) {
  const smartBack = useSmartBack()
  const isFromList = useIsFromList()

  const res2QueryParam = useRes2QueryString()

  const { area } = getFragmentData(RestaurantArea, props.restaurant)

  const showMinimums = area.minimums.length > 0
  // minimumAreaは複数ある場合でも、最初のもののみを表示する（管理画面上に説明書きあり）
  const areaLabel = showMinimums ? area.minimums[0].name : area.smallName

  const mediumAreaKey = area.mediumKey
  const smallAreaCode = area.smallCode
  const toSearchAreaLocation = showMinimums
    ? `/area/${mediumAreaKey}/${smallAreaCode}/${area.minimums[0].code}/?${res2QueryParam}`
    : `/area/${mediumAreaKey}/${smallAreaCode}/?${res2QueryParam}`

  return (
    <HeaderWrapper>
      <header
        className={center({
          position: 'relative',
          py: '2',
          px: '2',
          justifyContent: 'space-between',
          borderBottom: 'medium',
          minHeight: '[42px]',
          gap: '3',
        })}
      >
        <Link
          to={toSearchAreaLocation}
          className={center({ flex: '[2]', flexDirection: 'row', overflow: 'auto' })}
          onClick={smartBack}
        >
          <ChevronLeftOutlineIcon
            className={css({ color: 'gray.600' })}
            width="16px"
            height="16px"
          />
          <p
            className={css({
              flex: '1',
              textAlign: 'left',
              color: 'gray.800',
              truncate: true,
            })}
          >
            {isFromList ? '検索結果' : areaLabel}
          </p>
        </Link>
        <HeaderLogo />
        <SideMenuContainer className={css({ flex: '[2]' })} />
      </header>
    </HeaderWrapper>
  )
}
